import { createFileRoute } from '@tanstack/react-router'

import { ParentDetailsView } from '@/modules/students'

export const Route = createFileRoute(
  '/_auth/students-and-classes/students/parents/$parentId/details'
)({
  component: ParentDetailsView
})
